import React, { useEffect } from 'react';
import * as Sentry from '@sentry/browser';
import i18n from '@/settings/i18n';
import { FormatError } from '@/services/api';
import { LoginMenu } from '../Presentation/LoginMenu';
import { useFlashMessenger } from '@/hooks/useFlashMessenger';

type Props = {
  error: FormatError<any>;
  isLoggedIn: boolean;
};

export const LoginMenuContainer: React.FC<Props> = ({ error, isLoggedIn }) => {
  const { flashError } = useFlashMessenger();
  useEffect(() => {
    if (error) {
      Sentry.captureException(error);
      flashError(i18n.t('ui.error.unexpected'));
    }
  }, [error, flashError]);

  if (!isLoggedIn) {
    return null;
  }

  return <LoginMenu />;
};
